import { WeeklyUserPlanningDay } from "./WeeklyUserPlanningDay";
import { dateToAAAAMMJJ, dateWithoutHour, getWeekNumber } from "../../functions";

const WeeklyUserPlanning = (props) => {
    const { startDate, endDate, planning, selectedTimeSlots, publicHolidays, badgeages = [] } = props;

    function handleClickDate(val, ctrlKey) {
        props.onClickDate(val, ctrlKey);
    };

    function handleClickTimeSlots(tsId, ctrlKey) {
        props.onClickTimeSlots(tsId, ctrlKey);
    };

    function handleClickWeek(val, ctrlKey) {
        props.onClickWeek(val, ctrlKey)
    }

    const planningWithDate = () => {
        let aDate = dateWithoutHour(startDate);
        let arrayOfDate = [];
        while (aDate <= endDate) {
            arrayOfDate.push(dateWithoutHour(aDate));
            aDate.setDate(aDate.getDate() + 1);
        }
        const aResult = arrayOfDate.map((aDate) => {
            const aDay = {
                datePlanning: dateWithoutHour(aDate),
                timeSlots: planning && planning.filter((pl) => {
                    return (dateWithoutHour(pl.start_date).toDateString() == dateWithoutHour(aDate).toDateString()) | (dateWithoutHour(pl.end_date).toDateString() == dateWithoutHour(aDate).toDateString())
                }),
            }
            return aDay;
        })
        return aResult;
    }

    const weeksWithDays = () => {
        const days = planningWithDate();
        const weeks = [];
        let current = null;

        days.forEach((day, index) => {
            const isMonday = day.datePlanning.getDay() === 1;
            if (!current || isMonday || index === 0) {
                current = { weekNumber: getWeekNumber(day.datePlanning), days: [] };
                weeks.push(current);
            }
            current.days.push(day);
        });

        return weeks;
    };

    const columns = [...new Array(24)].map((val, index) => (index + 1) % 24);

    const isPublicHoliday = (date) => {
        return publicHolidays.some(holiday => holiday.date == dateToAAAAMMJJ(date, "-"));
    }

    const render = (
        <div className="m-0 text-xs">
            <div key="user_planning">
                {weeksWithDays().map((week) => (
                    <div key={week.weekNumber} className="print-week-block">
                        <div className="w-full p-0 flex my-px">
                            <div
                                className="w-1/12 flex py-1 border cursor-pointer hover:shadow-sm"
                                onClick={(e => { e.preventDefault(); handleClickWeek(week.days[0].datePlanning, e.ctrlKey) })}
                            >
                                <span className={"w-full text-center text-slate-700"}>Sem. {week.weekNumber}</span>
                            </div>
                            <div className="w-11/12 flex bg-slate-100 border-t border-b py-1">
                                {columns.map((hour, idx) =>
                                    <div key={idx} className={"w-[4.16667%] border-r flex"}>
                                        <div className="text-left w-1/2">{idx > 0 ? "h" : ""}</div>
                                        <div className="text-right w-1/2">{idx < 23 ? hour : ""}</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {week.days.map((day, index) => (
                            <WeeklyUserPlanningDay
                                key={day.datePlanning + index}
                                datePlanning={day.datePlanning}
                                timeSlots={day.timeSlots}
                                onClickDate={handleClickDate}
                                onClickTimeSlots={handleClickTimeSlots}
                                selectedTimeSlots={selectedTimeSlots}
                                isPublicHoliday={isPublicHoliday(day.datePlanning)}
                                dayLabel={publicHolidays.find(holiday => holiday.date == dateToAAAAMMJJ(day.datePlanning, "-"))?.label}
                                dayBadgeages={badgeages.filter((b) => {
                                    if (!b?.badged_at) return false;
                                    const bd = dateWithoutHour(new Date(b.badged_at));
                                    return bd.toDateString() === dateWithoutHour(day.datePlanning).toDateString();
                                })}
                            />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )

    return render;
};

export default WeeklyUserPlanning;